module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"purchasedGood":"Purchased good","cost":"Cost"},"et":{"purchasedGood":"Purchased good","cost":"Cost"},"ru":{"purchasedGood":"Purchased good","cost":"Cost"}}')
  delete Component.options._Ctor
}
